"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Geometry = _interopRequireDefault(require("../Geometry"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _GeometryCollection = _interopRequireDefault(require("../GeometryCollection"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _GeometryFilter = _interopRequireDefault(require("../GeometryFilter"));

var _List = _interopRequireDefault(require("../../../../../java/util/List"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeometryExtracter =
/*#__PURE__*/
function () {
  function GeometryExtracter() {
    _classCallCheck(this, GeometryExtracter);

    GeometryExtracter.constructor_.apply(this, arguments);
  }

  _createClass(GeometryExtracter, [{
    key: "filter",
    value: function filter(geom) {
      if (this._geometryType === null || GeometryExtracter.isOfType(geom, this._geometryType)) this._comps.add(geom);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryExtracter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_GeometryFilter.default];
    }
  }], [{
    key: "isOfType",
    value: function isOfType(geom, geometryType) {
      if (geom.getGeometryType() === geometryType) return true;
      if (geometryType === _Geometry.default.TYPENAME_LINESTRING && geom.getGeometryType() === _Geometry.default.TYPENAME_LINEARRING) return true;
      return false;
    }
  }, {
    key: "extract",
    value: function extract() {
      if (arguments.length === 2) {
        var geom = arguments[0],
            geometryType = arguments[1];
        return GeometryExtracter.extract(geom, geometryType, new _ArrayList.default());
      } else if (arguments.length === 3) {
        if ((0, _hasInterface.default)(arguments[2], _List.default) && arguments[0] instanceof _Geometry.default && typeof arguments[1] === "string") {
          var _geom = arguments[0],
              _geometryType = arguments[1],
              list = arguments[2];

          if (_geom.getGeometryType() === _geometryType) {
            list.add(_geom);
          } else if (_geom instanceof _GeometryCollection.default) {
            _geom.apply(new GeometryExtracter(_geometryType, list));
          }

          return list;
        } else if ((0, _hasInterface.default)(arguments[2], _List.default) && arguments[0] instanceof _Geometry.default && arguments[1] instanceof Class) {
          var _geom2 = arguments[0],
              clz = arguments[1],
              _list = arguments[2];
          return GeometryExtracter.extract(_geom2, GeometryExtracter.toGeometryType(clz), _list);
        }
      }
    }
  }]);

  return GeometryExtracter;
}();

exports.default = GeometryExtracter;

GeometryExtracter.constructor_ = function () {
  this._geometryType = null;
  this._comps = null;
  var geometryType = arguments[0],
      comps = arguments[1];
  this._geometryType = geometryType;
  this._comps = comps;
};